/* SLIDE 37 */
/* SLIDE 38 */
/* SLIDE 18 */

import React, { useState } from "react";
import ButtonBot from "shared/components/ButtonBot";
import searchIcon from "assets/icons/searchIcon.svg";
import { useNavigate } from "react-router-dom";
import SubHeader from "shared/components/SubHeader";
import SearchBar from "../../../shared/components/SearchBar";

const ParkingPaymentWaitAddress = () => {
    const navigation = useNavigate();

    const onNavi = (path) => {
        navigation(path);
    };

    const [showPopup, setShowPopup] = useState(false);

    const [searchValue, setSearchValue] = useState('');
    const [isSearched, setIsSearched] = useState(false);

    const handleInputChange = (e) => {
        setSearchValue(e.target.value); // get input value here
    };

    const handleSearchClick = () => {
        if (!searchValue)
            setIsSearched(false);
        else
            setIsSearched(true);
    };

    const parkingData = [
        {
            id: "1",
            name: "새마을시장주차장",
            postcode: "01 - 022",
            address: "서울 송파구 석촌호수로 72-5",
            regtime: "2024-10-10 13:57"
        },
        {
            id: "2",
            name: "○○○○○주차장",
            postcode: "01 - 022",
            address: "서울 송파구 ####",
            regtime: "2024-10-10 13:57"
        },
        {
            id: "3",
            name: "○○○○○주차장",
            postcode: "01 - 022",
            address: "서울 송파구 ####",
            regtime: "2024-10-10 13:57"
        },
        {
            id: "4",
            name: "○○○○○주차장",
            postcode: "01 - 022",
            address: "서울 송파구 ####",
            regtime: "2024-10-10 13:57"
        },
        {
            id: "5",
            name: "○○○○○주차장",
            postcode: "01 - 022",
            address: "서울 송파구 ####",
            regtime: "2024-10-10 13:57"
        },
        {
            id: "6",
            name: "○○○○○주차장",
            postcode: "01 - 022",
            address: "서울 송파구 ####",
            regtime: "2024-10-10 13:57"
        },
    ];

    return (
        <div className="parking-status-container ">
            <SubHeader>
                <div className={`sub-header-text w-full`} >
                    <span className="htBold">주차장 검색</span>
                </div>
            </SubHeader>

            <SearchBar placeholder="근무지명 또는 관리번호로 검색..." value={searchValue} onChange={handleInputChange} handleSearchClick={handleSearchClick}></SearchBar>
            <div className="htContent">
                <div className="htSeparator"></div>
            </div>

            <div className="table-container">
                <table className="user-table">
                    <tbody>
                        {parkingData.map((item) => (
                            <tr key={item.id}>
                                <td className="htBold">{item.name}</td>
                                <td>
                                    {item.postcode}
                                </td>
                                <td>
                                    {item.address}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {isSearched ? (
                <ButtonBot textYes={"주차장 설정"} handleYes={() => onNavi("/parking_add_form")} />
            ) : (
                <ButtonBot textNo={"근무지 설정"} />
            )}
        </div>
    );
};

export default ParkingPaymentWaitAddress;
